import React from 'react';
import { getIn } from 'formik';

import styles from '../fieldStyles';

const RadioField = ({
  field,
  form: { setFieldValue, isSubmitting, errors, touched },
  label,
  options,
  inColumn
}) => {
  const handleChange = e => {
    const value = e.target.value;
    const realValue = value === 'true' ? true : value === 'false' ? false : value;
    setFieldValue(field.name, realValue);
  };
  const isTouched = getIn(touched, field.name);
  const error = getIn(errors, field.name);
  return (
    <div className={styles.fieldContainer}>
      <label className={styles.fieldLabel}>{label}</label>
      <div className={`${styles.radioFieldGroup} ${inColumn && styles.inColumn}`}>
        {options.map((option, idx) => (
          <div key={idx} className={styles.radioButton}>
            <label>
              <input
                {...field}
                type="radio"
                value={option.value}
                onChange={handleChange}
                checked={field.value === option.value}
                disabled={isSubmitting}
              />
              <div className={styles.radioButtonLabel}>
                {option.render ? option.render() : option.label}
              </div>
            </label>
          </div>
        ))}
      </div>
      {isTouched && error && <div className={styles.fieldError}>{error}</div>}
    </div>
  );
};

export default RadioField;
